import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f31a842"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "send-dialog-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "添加一个礼物", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "send-tips"
}
const _hoisted_5 = { class: "operat-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SendRow = _resolveComponent("SendRow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
      return (_openBlock(), _createBlock(_component_SendRow, {
        key: item._key,
        modelValue: item,
        levelList: _ctx.levelList,
        couponMap: _ctx.couponMap,
        style: {"margin-bottom":"10px"},
        onDelete: ($event: any) => (_ctx.removeRow(item))
      }, null, 8, ["modelValue", "levelList", "couponMap", "onDelete"]))
    }), 128)),
    _createElementVNode("div", {
      class: "send-add",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
    }, _hoisted_3),
    (!_ctx.list.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 这个规格没配礼物的话，用户买它会被拦在下单那一步（「该规格未配置发货方式」） "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_button, {
        onClick: _ctx.submit,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_link, {
        onClick: _ctx.close,
        underline: false
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}